import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import { Link } from "react-router-dom";
import TF from "../../assets/TransmissionFlush.png";

const TransmissionFlush = () => {
  return (
    <>
      <SeoHead
        title="Transmission Flush in Temecula | Advanced Automotive Smog"
        description="Transmission fluid flush in Temecula to replace old, worn fluid and help restore smooth shifting and long-term transmission health."
        path="/services/transmission-flush"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Transmission Flush"
          path="/services/transmission-flush"
          description="Transmission fluid flush in Temecula to replace old, worn fluid and help restore smooth shifting and long-term transmission health."
          serviceType="Transmission flush"
        />

        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          
          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={TF}
                alt="Transmission Flush Service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Transmission Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-navy-900 mb-3">
              Transmission Flush
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Keep your transmission shifting smoothly and extend the life of your drivetrain. 
              Our transmission flush service removes old, burnt, or contaminated fluid and replaces it with fresh, high-quality fluid.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is a Transmission Flush?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Transmission fluid breaks down over time due to heat and friction. Old fluid can cause slipping, delayed shifting, or overheating.
              <br /><br />
              A flush restores smooth shifting, improves component lubrication, and helps prevent costly{" "}
              <Link to="/transmission-repair" className="text-teal-600 hover:underline">
                transmission repairs
              </Link>
              .
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Improves shifting performance immediately
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Helps prevent overheating and transmission failure
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Restores fluid to optimal cleanliness and viscosity
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Extends lifespan of transmission components
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Highly recommended for high-mileage vehicles
              </li>
            </ul>

            {/* Button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>

            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default TransmissionFlush;
